export class EntityNotFoundInCacheError extends Error {
  constructor(message) {
    super(message);
  }
}

